.signet-snackbar {
  position: fixed;
  padding: 10px;
  background-color: #090909;
  color: #fff;
  border-radius: 5px;
  transition: opacity 0.1s ease-in-out;
  display: flex;
  align-items: start;
  justify-content: space-between;
  opacity: 0;
    .info-container{
      display: flex;
    }

  &.success {
    // background-color: rgba(102, 187, 106, 0.15);
    background-color: #e6eee3;
    color: #000000;

    .icon {
      color: #409565;
      margin-right: 5px;
    }
  }

  &.info {
    // background-color: rgba(96, 132, 212, 0.15);
    background-color: #e5e6f2;
    color: #0841bf;

    .icon {
      color: #0841bf;
      margin-right: 10px;
    }
  }

  &.warning {
    // background-color: rgba(214, 186, 113, 0.15);
    background-color: #f5eee3;
    color: #765e21;

    .icon {
      color: #765e21;
      margin-right: 10px;
    }
  }

  &.error {
    // background-color: rgba(232, 126, 124, 0.15);
    background-color: #f7e6e5;
    color: #000000;

    .icon {
      color: #f25341;
      margin-right: 10px;
    }
  }

  &.open {
    z-index: 9999999;
    opacity: 1;
  }

  &.top-left {
    top: 10px;
    left: 10px;
  }

  &.top-center {
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
  }

  &.top-right {
    top: 10px;
    right: 10px;
  }

  &.bottom-left {
    bottom: 10px;
    left: 10px;
  }

  &.bottom-center {
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }

  &.bottom-right {
    bottom: 10px;
    right: 10px;
  }

  &.xs {
    width: 200px;
  }

  &.sm {
    width: 300px;
  }

  &.md {
    width: 350px;
  }

  &.lg {
    width: 400px;
  }

  &.xl {
    width: 500px;
  }

  .message {
    font-size: 14px;
  }

  .action-container {
    display: flex;
    align-items: center;

    .action-btn {
      color: #9c27b0;
      font-size: 14px;
      margin-left: 10px;
    }

    .close-icon {
      cursor: pointer;
      line-height: 0 !important;
      margin-left: 10px;
    }
  }
}
